import React from 'react'
import '../../assets/css/custom.css'
import { Link } from 'react-router-dom'
import ConvertImage from '../content/convertImage'

const CardDashComponent = ({title, image, id}) => {
    // const elemen1 = document.querySelector('.card-new');
    // const elemen2 = document.querySelector('.card-new-container');

    // if(elemen1){
    //     elemen1.addEventListener('mouseover', function() {
    //         elemen2.style.boxShadow = '4px 4px 7px 0 rgba(207, 207, 207, 0.2)';
    //         elemen2.style.border = 'solid 3px rgb(87, 108, 188)';
    //     });
    //     elemen1.addEventListener('mouseout', function() {
    //         elemen2.style.boxShadow = ''; // Kembalikan ke warna latar belakang awal
    //         elemen2.style.border = ''; // Kembalikan ke warna teks awal
    //     });
    // }

    return (
    <div className="card-new card-new-img">
        <Link to={'/SummaryJPO/'+ id}>
        <div className="card-new-container">
            <div className='card-new-img-container'>
                <ConvertImage imageString={image} />
            </div>
            <div className='card-new-content card-new-content-img'>
                <h5><b>{title}</b></h5> 
            </div>
        </div>
        </Link>
    </div>
    )
}

export default CardDashComponent